var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.153412 2.49757L5.72078 8.06494L0.153412 13.6323C-0.00774916 13.7935 -0.00774848 14.0572 0.153412 14.2184L1.91153 15.9765C2.07269 16.1376 2.33641 16.1376 2.49757 15.9765L8.06494 10.4091L13.6323 15.9765C13.7935 16.1376 14.0572 16.1376 14.2184 15.9765L15.9765 14.2184C16.1376 14.0572 16.1376 13.7935 15.9765 13.6323L10.4091 8.06494L15.9765 2.49757C16.1376 2.33641 16.1376 2.07269 15.9765 1.91153L14.2184 0.153412C14.0572 -0.00774865 13.7935 -0.00774877 13.6323 0.153412L8.06494 5.72078L2.49757 0.153412C2.33641 -0.00774877 2.07269 -0.00774865 1.91153 0.153412L0.153412 1.91153C-0.00774916 2.07269 -0.00774927 2.33641 0.153412 2.49757Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8e2803d1.svg";
export { ForwardRef as ReactComponent };